export const CREDIT_CARDS_API_URL = 'ui/organization/credit_cards';

export const creditCardsQueryKeys = {
  all: [CREDIT_CARDS_API_URL],
};
